import React, { useState } from 'react';

import api, { setToken } from '../../utils/api';
import { classNames } from '../../utils/utils';

const login = (onLogin, setBusy, setError, credentials) => {
  setBusy(true);

  api
    .post('/auth/login', { body: credentials })
    .then(({ access_token }) => {
      setToken(access_token);
      onLogin();
    })
    .catch(err => {
      if (err.status === 401) {
        setError('Uw gebruikersnaam of wachtwoord is incorrect.');
      } else if (err.status === 429) {
        setError('Te veel inlogpogingen. Probeer het later opnieuw');
      } else {
        setError('Er is iets fout gelopen. Probeer het later opnieuw');
      }

      setBusy(false);
    });
};

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState();
  const [busy, setBusy] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="max-w-lg w-full py-12 px-6">
        <div className="flex justify-center">
          <img src={`${process.env.PUBLIC_URL}/logo-dieter.png`} alt="Logo Dieter Dewulf Photography" className="w-42" />
        </div>
        <p className="mt-8 leading-5 text-center text-black">
          Vul je logingegevens in om toegang te krijgen tot het fotoarchief. Problemen of hulp nodig? Bel <a href="tel:+32493556087">0493/55 60 87</a>.
        </p>
        <form className="mt-8 flex flex-col gap-6">
          <input
            className={classNames(
              'text-sm relative focus:z-20 appearance-none w-full px-3 py-3 text-gray-900 focus:outline-none leading-5 border-2 border-gray-400 placeholder:text-black tracking-[2px] focus:border-black transition-colors',
              error ? 'border-red-600' : 'border-gray-300'
            )}
            placeholder="GEBRUIKERSNAAM"
            type="text"
            name="username"
            value={username}
            onChange={e => setUsername(e.target.value)}
          />
          <div className="relative">
            <input
              className={classNames(
                'text-sm relative focus:z-20 appearance-none w-full px-3 py-3 text-gray-900 focus:outline-none leading-5 border-2 border-gray-400 placeholder:text-black tracking-[2px] focus:border-black transition-colors',
                error ? 'border-red-600' : 'border-gray-300'
              )}
              placeholder="WACHTWOORD"
              name="password"
              value={password}
              type={showPassword ? 'text' : 'password'}
              onChange={e => setPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowPassword(prev => !prev)}
              className="absolute inset-y-0 right-3 flex items-center text-gray-900 hover:text-black cursor-pointer"
            >
              {showPassword ? (
                /* Eye off */
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                </svg>

              ) : (
                /* Eye */
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>

              )}
            </button>
          </div>
          {error && <p className="mt-1 mb-4 text-red-600">{error}</p>}

          <button
            type="button"
            disabled={busy}
            className="text-sm block w-full cursor-pointer border-2 py-3 uppercase spacing font-light tracking-[5px] group hover:bg-gray-100 hover:border-gray-100 transition-colors relative"
            onClick={() => login(onLogin, setBusy, setError, { username, password })}
          >
            Inloggen
            <div className="absolute right-8 top-0 h-full flex items-center group-hover:right-4 transition-all">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="size-5 opacity-0 group-hover:opacity-100 transition">
                <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
              </svg>
            </div>
          </button>
        </form>
      </div>
    </div>
  );
};

Login.defaultProps = {
  onLogin: () => { },
};

export default Login;
